<header class="banner">
    <div class="top-bar">
        <div class="logo">
            <a routerLink="/market" routerLinkActive="active">
                <h1 class="logo-text">Watchzaar</h1>
            </a>
        </div>

        <div class="custom-search">
            <mat-icon class="search-icon" fontIcon="search"></mat-icon>
            <input type="text" placeholder="Buscar..." />
        </div>

        <div class="auth">
            <button mat-flat-button class="btn" *ngIf="!username" [routerLink]="['/auth/login']">
                <mat-icon class="auth-icon" fontIcon="person"></mat-icon>
                <p class="auth-text">Login or Register</p>
            </button>

            <button mat-flat-button class="btn" *ngIf="username" [matMenuTriggerFor]="userMenu">
                <mat-icon class="auth-icon" fontIcon="person"></mat-icon>
                <p class="auth-text">{{ username }}</p>
            </button>

            <mat-menu #userMenu="matMenu">
                <button mat-menu-item [routerLink]="['/admin']" *hasRole="[Role.ADMIN]">
                    <mat-icon>admin_panel_settings</mat-icon> Administration
                </button>
                <button mat-menu-item [routerLink]="['/market']" *hasRole="[Role.ADMIN]">
                    <mat-icon>storefront</mat-icon> Market
                </button>
                <button mat-menu-item (click)="logout()"><mat-icon>logout</mat-icon> Logout</button>
            </mat-menu>
        </div>
    </div>

    <app-main-menu></app-main-menu>

    <app-breadcrumb *ngIf="showBreadcrumb"></app-breadcrumb>
</header>